import { render, staticRenderFns } from "./PersonalDetail.vue?vue&type=template&id=6290e44f&scoped=true"
import script from "./PersonalDetail.vue?vue&type=script&lang=js"
export * from "./PersonalDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonalDetail.vue?vue&type=style&index=0&id=6290e44f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6290e44f",
  null
  
)

export default component.exports